module.exports = __webpack_public_path__ + "img/p1.c920ee37.png";